import { render, staticRenderFns } from "./ProcessedSampleView.vue?vue&type=template&id=39082153&"
import script from "./ProcessedSampleView.vue?vue&type=script&lang=ts&"
export * from "./ProcessedSampleView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports